module.exports = __webpack_public_path__ + "static/media/background-login.fe1276a3.png";